/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PersonFieldCategories {
	Person = "Person",
	CompanyData = "CompanyData",
	CompanyPersonContactInfo = "CompanyPersonContactInfo",
	UserBasicInfo = "UserBasicInfo",
	UserAccountInfo = "UserAccountInfo",
	StartupperBasicInfo = "StartupperBasicInfo",
	StartupperContactInfo = "StartupperContactInfo",
	StartupperAdditionalInfo = "StartupperAdditionalInfo",
	ImmigrantBasicInfo = "ImmigrantBasicInfo",
	ImmigrantContactInfo = "ImmigrantContactInfo",
	ImmigrantResidenceInfo = "ImmigrantResidenceInfo",
	ImmigrantIntegrationInfo = "ImmigrantIntegrationInfo",
	ImmigrantFamily = "ImmigrantFamily",
	ImmigrantExperienceAndSkills = "ImmigrantExperienceAndSkills",
	ImmigrantWorkExperience = "ImmigrantWorkExperience",
	ImmigrantEducation = "ImmigrantEducation",
	JobSeekerBasicInfo = "JobSeekerBasicInfo",
	JobSeekerContactInfo = "JobSeekerContactInfo",
	JobSeekerUnemploymentInfo = "JobSeekerUnemploymentInfo",
	JobSeekerExperienceAndSkills = "JobSeekerExperienceAndSkills",
	JobSeekerWorkExperience = "JobSeekerWorkExperience",
	JobSeekerEducation = "JobSeekerEducation",
	JobSeekerOtherInfo = "JobSeekerOtherInfo",
	JobSeekerSkillwords = "JobSeekerSkillwords",
	LeaderBasicInfo = "LeaderBasicInfo",
	LeaderContactInfo = "LeaderContactInfo",
}
